import { defineStore } from 'pinia';
import { ref } from 'vue';

/**
 * Shared store for surfacing critical, app-breaking errors that occur outside the
 * component tree (e.g. session bootstrap failures in router guards), where
 * ErrorBoundary's onErrorCaptured has no error to catch. ErrorBoundary reads
 * from this store to render the same ErrorState UI for both sources.
 */
export const useAppErrorStore = defineStore('appError', () => {
  const criticalError = ref<Error | null>(null);

  const setCriticalError = (error: Error) => {
    criticalError.value = error;
  };

  const clearCriticalError = () => {
    criticalError.value = null;
  };

  return {
    criticalError,
    setCriticalError,
    clearCriticalError,
  };
});
